import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { fetchMoEventsParticipants } from 'api/mo/mo.actions';
import { MoEventDetails } from './MoEventDetails';

const mapDispatchToProps = (dispatch: Function, ownProps: RouteComponentProps<{ eventId: string }>) => ({
  fetch: () => {
    const {
      match: {
        params: { eventId },
      },
    } = ownProps;

    return dispatch(fetchMoEventsParticipants(eventId));
  },
});

export const MoEventDetailsContainer = compose(
  withRouter,
  connect(null, mapDispatchToProps),
)(MoEventDetails) as React.ComponentType;
